import { AcademicCapIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { Button } from '@/components/ui/daisy';
import ComingSoonTooltip from '@/components/ui/custom/dataDisplay/ComingSoonTooltip';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { Breakpoints } from '@/utils/Breakpoint';

export default function QuestionBankButton() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab',
  });
  const isXl = useMediaQuery({ minWidth: Breakpoints.xl });

  if (isXl) {
    return (
      <ComingSoonTooltip disabled>
        <Button size="xs" color="secondary" variant="outline">
          <AcademicCapIcon className="w-3" />
          {t('questionBank')}
        </Button>
      </ComingSoonTooltip>
    );
  }

  return (
    <ComingSoonTooltip disabled>
      <Tooltip text={t('questionBank')}>
        <Button
          size="sm"
          variant="ghost"
          shape="square"
          aria-label={t('questionBank')}
        >
          <AcademicCapIcon className="w-5" />
        </Button>
      </Tooltip>
    </ComingSoonTooltip>
  );
}
